<template>
    <div>
    <div v-if="getShowModalMessageResult">{{processModalResult()}}</div>
    <div v-if="getAxiosRefresh == 3">{{initData()}}</div>
    <div v-if="getTaskPreparedEdit>-1">{{prepareEdit(getTaskPreparedEdit)}}</div>

    <v-layout row wrap v-if="getAxiosRefresh == -1 && myContent">
        <v-expansion-panels
                v-model="panels"
                multiple
                flat
                class="px-6"
            >
        <v-expansion-panel>
            <v-expansion-panel-header><b>Assignment</b></v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-flex xs12>                 
                <v-layout row wrap>               
                    <v-flex :xs12="getTaskVertic" :xs7="!getTaskVertic" v-if="getShowTaskIndex > -1"
                        :class="['card-border-style position-relative overflow-hidden read-only--background read-only--border-color', 
                                (getTaskVertic == true) ? 'rounded-tl-lg rounded-tr-lg':'rounded-tl-lg rounded-bl-lg']">

                            <div v-if="myContent.languages[getShowTaskIndex].permissions && !myContent.islocked" class="universal-row-item__group-btn-panel read-only--border-color">
                                <div class="lang-side">
                                    <img class="lang-side__img" :src="getLanguageIcons[getShowTaskIndex].url" />
                                </div>
                                <v-icon @click="prepareEdit(getShowTaskIndex)" dense>edit</v-icon>
                                <v-icon @click ="clearTranslation(getShowTaskIndex)" dense>delete</v-icon>                                
                                <v-icon v-if="myContent.languages[getShowTaskIndex].visible == 0" @click="changeVisibility(getShowTaskIndex)" dense>visibility_off</v-icon>                                       
                                <v-icon v-else @click="changeVisibility(getShowTaskIndex)" dense>visibility</v-icon>  
                                <v-icon class="border-l read-only--border-color" @click="$store.commit('setShowTaskIndex', -1); $store.commit('setTaskVertic', true)" dense>cancel</v-icon>
                            </div>                         
                            <div v-html="JSON.parse(myContent.languages[getShowTaskIndex].content).content" class="pa-2"></div>
                    </v-flex>

                    <v-flex :xs12="getTaskVertic" :xs5="!getTaskVertic" v-if="getEditTaskIndex > -1"
                        :class="['card-border-style position-relative overflow-hidden', 
                                (getShowTaskIndex > -1 && getTaskVertic == false) ? 'border-l-none rounded-tr-lg rounded-br-lg':'', 
                                (getShowTaskIndex > -1 && getTaskVertic == true) ? 'border-t-none rounded-br-lg rounded-bl-lg':'', 
                                (getShowTaskIndex > -1) ? '':'rounded-lg']">

                        <div class="universal-row-item__group-btn-panel">
                            <div class="lang-side">
                                <img class="lang-side__img" :src="getLanguageIcons[getEditTaskIndex].url" />
                            </div>

                            <v-menu v-if="getShowTaskIndex > -1" class="lang-wrapper" top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-bind="attrs" v-on="on" class="lang-change-widget background-transparent shadow-none" title="copy parts" dense>
                                    content_copy
                                    </v-icon>
                                </template>
                                    <v-list dense>
                                    <v-list-item-group>
                                        <v-list-item v-for="(copy, index) in copies" :key="index" @click="copyContent(copy.list)"> 
                                            <v-list-item-title>{{copy.name}}</v-list-item-title>
                                        </v-list-item>
                                    </v-list-item-group>
                                    </v-list>
                                </v-menu> 
                            <v-icon v-if="!myContent.islocked && !(myContent.id > 0 && getCountdownStatus.count <= 0)" title="save without close" @click="saveData(false, getEditTaskIndex, objectChangePermission?0:1)" dense>save</v-icon>
                            <v-icon v-if="!myContent.islocked && !(myContent.id > 0 && getCountdownStatus.count <= 0)" title="save and close" @click="saveData(true, getEditTaskIndex, objectChangePermission?0:1)" dense>check_circle</v-icon>
                            <v-icon title="close without save" @click="closeTask()" dense>meeting_room</v-icon>
                            
                            <v-icon class="border-l" @click="$store.commit('setEditTaskIndex', -1); $store.commit('setTaskVertic', true)" dense>cancel</v-icon>
                        </div>
                        <v-card flat class="pa-2">
                            <quill-editor v-model='tmpContent' :options="getEditorOption()" />  
                        </v-card>
                    </v-flex>                    
                </v-layout>
                </v-flex>
            </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
            <v-expansion-panel-header><b>Answers</b></v-expansion-panel-header>
            <v-expansion-panel-content>
                <div class="d-flex flex-row align-center vertically-horizontally-centered">
                    <v-btn v-if="myContent.task_type_id == 4" @click ="harmoniseAll()" title="Harmonise positive and negative answers" class="background-transparent card-custom-button shadow-none ml-auto">
                        <v-icon class="color--medium-emphasis">published_with_changes</v-icon>     
                    </v-btn>
                    <span><small>Sum/max of answer score: </small><br><span :style="sum_color"><small>{{sumOfAnswerScore}} / {{maxOfAnswerScore}}</small></span></span>
                </div>
                <v-flex xs12 v-if="getEditTaskIndex >-1 || getShowTaskIndex >-1">                                                                
                    <v-flex xs12 v-for="(rating_index,index) in rating_indexes" :key="index">
                        <v-layout v-if="tmpAnswers[index].status != 2" class="border-b--dashed pa-2">
                                <v-icon small @click ="tryDeleteAnswer(index)">delete</v-icon> 
                                <v-layout class="vertically-horizontally-centered">
                                    <v-flex xs2>
                                        <v-slider
                                            v-if="getEditTaskIndex > -1 || getShowTaskIndex > -1"
                                            v-model="rating_indexes[index]"
                                            min="0"
                                            :max="getRatingItems.length-1"
                                            :tick-size="6"
                                            :color="getRatingColor(getRatingItems[rating_indexes[index]])"
                                            :thumb-color="getRatingColor(getRatingItems[rating_indexes[index]])"
                                            thumb-label="always"                                        
                                            vertical
                                            :readonly = "!objectChangePermission"
                                            @change="countSumOfAnswerScore()"
                                        >
                                            <template v-slot:thumb-label="{ value }">
                                                {{ getRatingItems[value] }}
                                            </template>
                                        </v-slider>
                                    </v-flex>
                                    <v-flex xs10>
                                        <v-layout row wrap>
                                            <v-flex :xs12="getTaskVertic" :xs6="!getTaskVertic" v-if="getShowTaskIndex > -1" class="pa-2">
                                                <div class="read-only--background border-all read-only--border-color pa-2 fill-height">
                                                    <div v-if="JSON.parse(myContent.languages[getShowTaskIndex].content).answer_list.length > index">
                                                        <div v-html="JSON.parse(myContent.languages[getShowTaskIndex].content).answer_list[index].answer"></div>
                                                    
                                                        <small >{{JSON.parse(myContent.languages[getShowTaskIndex].content).answer_list[index].feedback}}</small>
                                                    </div>
                                                    <div v-else>
                                                        <p>-- not translated --</p>
                                                    </div>
                                                </div>
                                            </v-flex>
                                            <v-flex :xs12="getTaskVertic" :xs6="!getTaskVertic" v-if="getEditTaskIndex > -1" class="pa-2">
                                                <quill-editor v-if="showEditor" :options="getEditorOption('simple')" />
                                                <v-text-field v-else
                                                    v-model="tmpAnswers[index].answer"
                                                    label="Answer:"
                                                ></v-text-field>
                                                <v-text-field
                                                    v-model="tmpAnswers[index].feedback"
                                                    label="Feedback:"
                                                ></v-text-field>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                            </v-layout>    
                    </v-flex>               
                </v-flex>

                <v-flex xs12 v-if="objectChangePermission && (getEditTaskIndex >-1 || getShowTaskIndex >-1)" class="mt-3">
                    <v-card color = "#DDDDFF" flat>
                        <v-card-text>
                        <v-layout row justify-center>                
                            <v-menu class="lang-wrapper" top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on" class="lang-change-widget background-transparent shadow-none">
                                mdi-plus-circle-outline
                                </v-icon>
                            </template>
                                <v-list dense>
                                <v-list-item-group>
                                    <v-list-item @click="addOption(0)" v-if="myContent.task_type_id == 4 "> 
                                        <v-icon style="margin-right:3px">sentiment_neutral</v-icon><v-list-item-title>empty option</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="addOption(1)"> 
                                        <v-icon style="margin-right:3px">mood</v-icon><v-list-item-title>correct option <span v-if="myContent.task_type_id==4">(auto recalc)</span></v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="addOption(-1)"> 
                                        <v-icon style="margin-right:3px">mood_bad</v-icon><v-list-item-title>incorrect option <span v-if="myContent.task_type_id==4">(auto recalc)</span></v-list-item-title>
                                    </v-list-item>
                                </v-list-item-group>
                                </v-list>
                            </v-menu>                              
                        </v-layout>        
                        </v-card-text>
                    </v-card> 
                </v-flex>
            </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
            <v-expansion-panel-header><b>Help</b></v-expansion-panel-header>
            <v-expansion-panel-content>            
            <v-flex xs12>
                <v-layout row wrap>                      
                    <v-flex :xs2="!getTaskVertic">&nbsp;</v-flex>                  
                    <v-flex :xs12="getTaskVertic" :xs5="!getTaskVertic" v-if="getShowTaskIndex > -1" class="pa-2">
                        <div v-html="JSON.parse(myContent.languages[getShowTaskIndex].content).help" class="read-only--background border-all read-only--border-color pa-2 fill-height"></div>
                    </v-flex>
                    <v-flex :xs12="getTaskVertic" :xs5="!getTaskVertic" v-if="getEditTaskIndex > -1" class="pa-2">
                        <quill-editor v-model='tmpHelp' :options="getEditorOption()" />                        
                    </v-flex>
                </v-layout>                        
            </v-flex>
            </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>            
            <v-expansion-panel-header><b>Settings</b></v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-layout row wrap>
                    <v-flex xs1>                                                        
                        <v-text-field
                            v-model="myContent.max_score"
                            label="Max score:"
                            outlined
                            :rules="[rules.required, rules.content, rules.size]"
                            :readonly = "!objectChangePermission"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs1>  </v-flex>
                    <v-flex xs3 v-if="myContent.task_type_id == 2">>
                        <v-checkbox
                            v-model="myGlobals.ignoreSpace"
                            label="Ignore spaces"
                            :readonly="!objectChangePermission"
                        ></v-checkbox>     
                        <v-checkbox
                            v-model="myGlobals.ignoreSeparators"
                            label="Ignore separators (-_,.)"
                            :readonly="!objectChangePermission"
                        ></v-checkbox>     
                        <v-checkbox
                            v-model="myGlobals.caseSensitive"
                            label="Case sensitive"
                            :readonly="!objectChangePermission"
                        ></v-checkbox>     
                        <v-checkbox
                            v-model="myGlobals.aqSome"
                            label="Apostrophe and quotation marks are the same "
                            :readonly="!objectChangePermission"
                        ></v-checkbox>     
                    </v-flex>
                    <v-flex xs2></v-flex>
                    <v-flex xs4 v-if="objectChangePermission"> 
                        <v-layout row justify-end>                                               
                            <v-menu class="lang-wrapper" top>                        
                            <template v-slot:activator="{ on, attrs }">
                                <div v-bind="attrs" v-on="on" class="lang-change-widget background-transparent shadow-none">
                                <v-btn class="background-transparent card-custom-button shadow-none">
                                    <v-icon class="mr-3 pr-3 border-r" dense>
                                        {{task_icons[myContent.task_type_id-1].icon}}                             
                                    </v-icon>
                                    {{task_icons[myContent.task_type_id-1].descr}}  
                                </v-btn>    
                                </div>                                               
                            </template>
                                <v-list dense>
                                <v-list-item-group>
                                    <v-list-item @click="myContent.task_type_id = 2">
                                        <v-icon style="margin-right:3px">{{task_icons[1].icon}}</v-icon><v-list-item-title v-text="task_icons[1].descr"></v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="myContent.task_type_id = 3">
                                        <v-icon style="margin-right:3px">{{task_icons[2].icon}}</v-icon><v-list-item-title v-text="task_icons[2].descr"></v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="myContent.task_type_id = 4">
                                        <v-icon style="margin-right:3px">{{task_icons[3].icon}}</v-icon><v-list-item-title v-text="task_icons[3].descr"></v-list-item-title>
                                    </v-list-item>
                                </v-list-item-group>
                                </v-list>
                            </v-menu>                              
                        </v-layout>
                    </v-flex>
                </v-layout>               
            </v-expansion-panel-content>
        </v-expansion-panel>
        </v-expansion-panels>
        </v-layout>

        <v-layout v-if="myContent && getEditTaskIndex>-1" class="d-flex align-end flex-column border-t mt-5 pa-2">
            <div class="btn-group-a">
                <img class="btn-group-a__divider-item" :src="getLanguageIcons[getEditTaskIndex].url" width="20" />
                <v-icon v-if="!myContent.islocked && !(myContent.id > 0 && getCountdownStatus.count <= 0)" title="save without close" @click="saveData(false, getEditTaskIndex, objectChangePermission?0:1)" class="btn-group-a__button btn-group-a__button--green" dense>save</v-icon>
                <v-icon v-if="!myContent.islocked && !(myContent.id > 0 && getCountdownStatus.count <= 0)" title="save and close" @click="saveData(true, getEditTaskIndex, objectChangePermission?0:1)" class="btn-group-a__button btn-group-a__button--blue" dense>check_circle</v-icon>
            </div>
        </v-layout>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
import * as es from '../../../../assets/editor_settings.js'
import axios from '../../../../axios-auth'
import * as icn from '../../../../assets/task_icons.js'
import * as misc from '../../../../assets/misc.js'

export default {
    data() {
        return {
                myContent: null,
                myGlobals: null,
                sum_color: '',
                sumOfAnswerScore: 0,
                maxOfAnswerScore: 0,
                task_icons: [],
                tmpContent: '',
                tmpHelp: '',
                tmpAnswers: [],
                rating_indexes: [],
                showEditor: false,
                deleteIndex: -1,
                rules: {
                    required: value => !!value || 'Required.',
                    size: value => value > 0 && value < 1000 || 'Out of size.',
                    content: value => {
                        const pattern = /^\d+$/
                        return pattern.test(value) || 'Invalid value.'
                    }
                },
                copies: [ { name: 'content', list: ['content'] }, // menu content
                          { name: 'content, help', list: ['content', 'help'] },
                          { name: 'content, help, answers', list: ['content', 'help', 'answers'] },
                          { name: 'content, help, answers, feedback', list: ['content', 'help', 'answers','feedback'] },
                          { name: 'answers', list: ['answers'] },
                          { name: 'answers, feedback', list: ['answers', 'feedback'] }
                ],
                panels : [0]
              }
    },
    props: {
        my_element: Object, 
        objectChangePermission : Boolean
    },
    computed: 
            mapGetters([
                        'getLanguageIcons',
                        'getCountdownStatus',
                        'getShowTaskIndex',
                        'getEditTaskIndex',
                        'getTaskVertic',
                        'getTaskPreparedEdit',
                        'getRatingItems',
                        'getShowModalMessageResult',
                        'getAxiosRefresh'
                        ])
    ,
    components: {
        quillEditor
    },
    mounted() {
        if (this.getAxiosRefresh !=3 ) this.initData()
    },
    methods: {
        // ************ main methods
        getEditorOption(_version) { return es.getEditorOption(_version) },
        getCmOptions() { return es.getCmOptions('text/html', false) },   
        changeVisibility(_index) {
            this.$store.commit('setTaskNewVisibility', 1 - this.myContent.languages[_index].visible)
            this.$store.commit('setTaskChangeVisibility', true)
            this.myContent.languages[_index].visible = 1 - this.myContent.languages[_index].visible                   
        },
        prepareEdit(_index) {  
            this.$store.commit('setTaskPreparedEdit',-1)  
            if (!this.myContent.languages[_index].permissions || this.myContent.islocked) return
            this.$store.commit('setEditTaskIndex', _index)
            this.prepareContent(1)
        },
        closeTask() { this.$router.go(-1) },

        // ******** end of main methods
        // *********************************

        initData() {
            // this.$store.commit('setFeedback', null)
            this.$store.commit('setAxiosRefresh',-1)
            this.myContent = this.my_element
            this.task_icons = icn.getIcons()
            this.myGlobals = {
                ignoreSpace: false,   
                ignoreSeparators: false,   
                caseSensitive: true,
                aqSome: false
            }
            this.rating_indexes = []

            const _glob = misc.getFromJSON(this.myContent.globals,'')
            if (_glob != '') {
                if (!isNaN(_glob.ignoreSpace)) this.myGlobals.ignoreSpace = _glob.ignoreSpace
                if (!isNaN(_glob.ignoreSeparators)) this.myGlobals.ignoreSeparators = _glob.ignoreSeparators
                if (!isNaN(_glob.caseSensitive)) this.myGlobals.caseSensitive = _glob.caseSensitive
                if (!isNaN(_glob.aqSome)) this.myGlobals.aqSome = _glob.aqSome
                const _rt = _glob.ratings
                for(let i=0; i < _rt.length; i++) {
                    this.rating_indexes.push(misc.getIndex(this.getRatingItems,_rt[i]))
                }                
            }

            if (this.$route.params.id == 0) this.myContent.max_score = 10


            if (this.getEditTaskIndex > -1 && (!this.myContent.languages[this.getEditTaskIndex].permissions || this.myContent.islocked)) {
                this.$store.commit('setEditTaskIndex', -1)
                this.$store.commit('setTaskVertic',true)
            }
            if (this.getShowTaskIndex == this.getEditTaskIndex) {
                this.$store.commit('setShowTaskIndex', -1)
                this.$store.commit('setTaskVertic',true)
                this.prepareEdit(this.getEditTaskIndex)
            }                    
            this.prepareContent(0)   
            this.countSumOfAnswerScore()  
        },
        prepareContent(_old) {            
            var _json=''
            if (this.getEditTaskIndex < 0) {
              _json = misc.getFromJSON(this.myContent.languages[this.getShowTaskIndex].content,'')
            } else {
              _json = misc.getFromJSON(this.myContent.languages[this.getEditTaskIndex].content,'')  
            }
            this.tmpContent = ''
            this.tmpHelp = ''
            if (_json != '') {
                this.tmpContent = _json.content
                this.tmpHelp = _json.help
                if (this.tmpAnswers.length == 0) {
                    // first question open
                    this.tmpAnswers = _json.answer_list
                    for(let i = 0; i<this.tmpAnswers.length; i++) {
                        this.tmpAnswers[i].status = 0
                    }
                } else {
                    // copy saved answers
                    const _tmp = _json.answer_list
                    for(let i = 0; i<_tmp.length; i++) {
                        this.tmpAnswers[i].answer = _tmp[i].answer
                        this.tmpAnswers[i].feedback = _tmp[i].feedback
                        this.tmpAnswers[i].status = this.tmpAnswers[i].status * _old                        
                    }
                    // clear added
                    for(let i = _tmp.length; i<this.tmpAnswers.length; i++) {
                        this.tmpAnswers[i].answer = ''
                        this.tmpAnswers[i].feedback = ''
                        this.tmpAnswers[i].status = this.tmpAnswers[i].status * _old
                    }
                }                
            } else { //_json is empty
                if (this.tmpAnswers.length == 0) {
                    // first refresh - new language
                    for(let i = 0; i<this.rating_indexes.length; i++) {
                        this.tmpAnswers.push({answer:'', feedback:'', status: 1})
                    }
                } else {
                    // refresh new language
                    for(let i = 0; i<this.tmpAnswers.length; i++) {
                        this.tmpAnswers[i].answer = ''
                        this.tmpAnswers[i].feedback = ''
                        this.tmpAnswers[i].status = this.tmpAnswers[i].status * _old
                    }   
                }
            }
        },
        copyContent(_list) {
            if (this.getShowTaskIndex > -1) {
                const _json = misc.getFromJSON(this.myContent.languages[this.getShowTaskIndex].content,'')
                if (_json != '') {
                    if (_list.includes('content')) this.tmpContent = _json.content
                    if (_list.includes('help')) this.tmpHelp = _json.help
                    if (_list.includes('answers')) {
                        for(let i=0; i < _json.answer_list.length; i++)
                            this.tmpAnswers[i].answer = _json.answer_list[i].answer
                    }
                    if (_list.includes('feedback')) {
                        for(let i=0; i < _json.answer_list.length; i++)
                           this.tmpAnswers[i].feedback = _json.answer_list[i].feedback
                    }
                }              
            }
        },
        addOption(_type) {            
            this.tmpAnswers.push({answer:'', feedback:'', status: 1})
            if (_type == 0 || (this.myContent.task_type_id < 4 && _type == -1)) {
                this.rating_indexes.push(this.getRatingItems.indexOf(0))
                return
            }
            if (_type == 1) {
                this.rating_indexes.push(this.getRatingItems.indexOf(100))
                if (this.myContent.task_type_id == 4) this.harmoniseRatings(1)
            }
            if (_type == -1) {
                this.rating_indexes.push(this.getRatingItems.indexOf(-100))
                this.harmoniseRatings(-1)
            }
        },
        harmoniseRatings(_type) {
            var _cp = 0
            var _cn = 0
            for(let i = 0; i< this.rating_indexes.length; i++) {
                if (this.tmpAnswers[i].status != 2) {
                    const _x = this.getRatingItems[this.rating_indexes[i]]
                    if (_x > 0) {_cp += 1;}
                    if (_x < 0) {_cn += 1;}
                }
            }
            if (_type == 1) {
                const _value = Math.round(10000/_cp)/100
                const index = this.getRatingItems.indexOf(_value)
                for(let i = 0; i< this.rating_indexes.length; i++) {
                    if (this.getRatingItems[this.rating_indexes[i]] > 0) {this.rating_indexes[i] = index}
                }
            }
            if (_type == -1) {
                const _value = -Math.round(10000/_cn)/100
                const index = this.getRatingItems.indexOf(_value)
                for(let i = 0; i< this.rating_indexes.length; i++) {
                    if (this.getRatingItems[this.rating_indexes[i]] < 0) {this.rating_indexes[i] = index}
                }
            }
            this.countSumOfAnswerScore()  
        },
        harmoniseAll() {
            this.harmoniseRatings(1)
            this.harmoniseRatings(-1)

        },
        clearTranslation(_index) { 
            if (!this.myContent.languages[_index].translated) return
            this.tmpContent = ''
            this.tmpHelp = ''
            this.tmpAnswers = []
            this.saveData(false,_index, 1)
            this.$store.commit('setShowTaskIndex', -1)
        },
        saveData(_close, _index, _only_translation) { 
          if (this.myContent.id == 0 && (this.myContent.course_id === undefined || this.myContent.lesson_id === undefined)) {
              this.$store.commit('setFeedback', 'Data about course and/or lesson is missing')
              return
          }
          this.myContent.max_score = isNaN(this.myContent.max_score) ? 10 : this.myContent.max_score

          const _content = {
              content: this.tmpContent,
              help: this.tmpHelp,
              answer_list: this.tmpAnswers
          }
          const _globals = {
              ratings: this.prepareRatings(),
              ignoreSpace: this.myGlobals.ignoreSpace,
              ignoreSeparators: this.myGlobals.ignoreSeparators,
              caseSensitive: this.myGlobals.caseSensitive,
              aqSome: this.myGlobals.aqSome
          }
          const _data = {
            task_id: this.myContent.id,
            course_id: this.myContent.course_id, // will be checked on backend
            lesson_id: this.myContent.lesson_id,
            task_type: 'T',
            task_type_id: this.myContent.task_type_id,
            max_score: this.myContent.max_score,
            content: JSON.stringify(_content), // new data
            globals: JSON.stringify(_globals),
            lang_id: _index + 1,
            only_translation: _only_translation 
          }

        axios.post('/edit-task', _data, this.$store.getters.getAxiosConfig)
          .then(res => {
            if (res.data.message != 'OK') {
              this.$store.commit('setFeedback', res.data.message)
              return
            } 
            if (this.myContent.id == 0 || this.myContent.task_type_id != this.$route.params.id_type) { // new - refresh                  
                if (this.myContent.id == 0) 
                   this.myContent.id = res.data.task_id
                   
                this.$store.commit('setShowTaskIndex', _index)
                this.$store.commit('setEditTaskIndex', _index)

                this.$router.replace({name:'task_edit', params: {
                    id: this.myContent.id,
                    id_type: this.myContent.task_type_id, 
                    show_lang: _index, 
                    edit_lang: _index, 
                    course_id: this.myContent.course_id, 
                    lesson_id: this.myContent.lesson_id
                }})
            }

            if (_close) this.closeTask()   
            this.$store.commit('setAxiosRefresh', 1)
          })
          .catch(error => {
              this.$store.commit('setFeedback', error)
          }) 
        }, 
        getRatingColor(_value) {
            if (_value == 0) return "blue"
            if (_value > 0) return "green"
            return "red"
        },
        countSumOfAnswerScore() {
            var _sum = 0           
            var _max = 0 
            for(let i=0; i < this.rating_indexes.length; i++) {
                if (this.tmpAnswers[i].status != 2) {
                    let x = this.getRatingItems[this.rating_indexes[i]] 
                    _sum += x
                    if (_max < x) _max = x
                }
            }
            this.sumOfAnswerScore = Math.round(_sum)
            this.maxOfAnswerScore = Math.round(_max)
            this.sum_color = (this.sumOfAnswerScore == 0 && this.myContent.task_type_id == 4) || (this.maxOfAnswerScore == 100 && this.myContent.task_type_id == 3) || (this.maxOfAnswerScore == 100 && this.myContent.task_type_id == 2) ? 'color:green' : 'color:red'
        },
        tryDeleteAnswer(index) {
            this.deleteIndex = index
            if (this.tmpAnswers[index].status != 1) {
                this.$store.commit('setShowModalMessage',
                    {content: 'Are you sure?<br/>You want to delete answer? <br /> You will delete answers in ALL languages', type: 'warning', 
                    buttons:[], icons:[{text:'close', color:'red', value: 1},{text:'done', color:'green', value: 2} ]})
            } else {
                this.deleteAnswer()
            }
        },
        processModalResult() {            
            const res = this.getShowModalMessageResult
            this.$store.commit('setShowModalMessageResult',null)
            if (res == 2) this.deleteAnswer()        
        },
        deleteAnswer() {
            if (this.tmpAnswers[this.deleteIndex].status == 1) {
                this.tmpAnswers.splice(this.deleteIndex,1)
                this.rating_indexes.splice(this.deleteIndex,1)
            } else {
                this.tmpAnswers[this.deleteIndex].status = 2
            }
        },
        prepareRatings() {
            var _rat = []
            for(let i=0; i<this.rating_indexes.length; i++) {
                if (this.tmpAnswers[i].status != 2)
                  _rat.push(this.getRatingItems[this.rating_indexes[i]])
            }
            return _rat
        },  
    }
}
</script>

<style>

</style>

